/**
 * THIS FILE IS AUTOGENERATED, DO NOT EDIT IT!
 *
 * instead, edit one of the `.graphql` files in this project and run
 * `pnpm nx run graphql:codegen `
 * for this file to be re-created
 */
import * as Types from '@main/graphql/types.generated';

import type { TypedDocumentNode } from '@graphql-typed-document-node/core';
import * as ClientTypes from '@main/graphql/client-scalars';
import { api } from '@main/graphql/shared-api';
export type GetSharepointFileMetadataQueryVariables = Types.Exact<{
  orgIntegrationId: Types.Scalars['uuid']['input'];
  fileUrl: Types.Scalars['String']['input'];
}>;

export type GetSharepointFileMetadataQuery = {
  __typename?: 'query_root';
  sharepoint_file_metadata?: {
    __typename?: 'SharepointFileMetadata';
    success?: {
      __typename?: 'SpFileMetadataSuccess';
      driveId: string;
      driveName: string;
      fileId: string;
      fileName: string;
      filePath: string;
    } | null;
    error?: {
      __typename?: 'SpFileMetadataError';
      type: Types.SpFileMetadataErrorType;
      message?: string | null;
    } | null;
  } | null;
};

export const GetSharepointFileMetadataDocument = `
    query GetSharepointFileMetadata($orgIntegrationId: uuid!, $fileUrl: String!) {
  sharepoint_file_metadata(orgIntegrationId: $orgIntegrationId, fileUrl: $fileUrl) {
    success {
      driveId
      driveName
      fileId
      fileName
      filePath
    }
    error {
      type
      message
    }
  }
}
    ` as string &
  TypedDocumentNode<GetSharepointFileMetadataQuery, GetSharepointFileMetadataQueryVariables>;

const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    GetSharepointFileMetadata: build.query<
      GetSharepointFileMetadataQuery,
      GetSharepointFileMetadataQueryVariables
    >({
      query: (variables) => ({ document: GetSharepointFileMetadataDocument, variables }),
    }),
  }),
});

export { injectedRtkApi as api };
export const { useGetSharepointFileMetadataQuery, useLazyGetSharepointFileMetadataQuery } =
  injectedRtkApi;
